import { NewOrderNotification } from '@/features/notifications/notification-service-extension-shared/types/app'
import { TFunction } from 'i18next'

export const getNewOrderProps = (notification: NewOrderNotification, t: TFunction<'app'>) => {
    const title = `${t(`order.deliveryTypeCategory.${notification.orderDeliveryTypeCategory}`, notification.orderDeliveryTypeCategory)} | ${t(`order.channel.${notification.orderChannel}`, notification.orderChannel)}`

    return {
        title,
        orderShortCode: notification.orderShortCode,
        orderCustomerName: notification.orderCustomerName,
    }
}
